import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Cell, CellClient } from "../../../../../backend/backendapi";
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { WindowType } from "../../../../../../util";
import { initClient } from "../../../../../../api";

declare var window: WindowType;

export class Meters  {
    kmMeter?: number;
    Tank1?: number;
    Tank2?: number;
    TankDesk?: string;
    MotorMeter1?: number;
    MotorMeter2?: number;
    CableHours?: number;
    MotorDesc?: string;
    OilLevel1?: number;
    OilLevel2?: number;
    OilDescr?: string;
    LiquidLevel1?: number;
    LiquidLevel2?: number;
    LiquidDescr?: string;
}

@Component({
    name: 'MeterTab',
    components: {
        VueGoodTable,
    },
})
export default class MeterTab extends Vue {
    @Prop({ required: true })
    private readonly cell!: Cell | undefined;
    private misc: Meters = new Meters();
    private isMaintenance: boolean = true;

    //api
    private readonly cellAPI = initClient(CellClient);

    //runtime

    //config
    //mount
    async mounted(): Promise<void> {
        this.isMaintenance = window.application.check2.isMaintenanceMode;
    }

    //data

    //computed
}